<template>
  <div class="global-feed-container global-feed-timeline" >
    <div class="global-feed-title-area">
      <div class="global-feed-title">{{feedTitle}}</div>
    </div>
    <div id="global-feed-article-list-area">
      <div
        v-for="(feedItem, feedIndex) in feedItems"
        :class="{'global-feed-ad-pure': feedItem.adPure}"
        :id="feedItem.adId"
        class="global-feed-article-list"
      >
        <feed-item
          v-if="!feedItem.ad"
          :feed-param = "feedParam"
          :feed-item  = "feedItem"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ErrorReporter     from '@istyle-inc/js-error-reporter/vue-error-reporter';
import FeedItem          from './global-feed/feed-item';
import FeedApiClient     from '../../libs/ipfeed-api-client';
import FeedAd            from '../../libs/feed-ad';
import Config            from '../../libs/config';

const apiClient         = new FeedApiClient();
const feedAd            = new FeedAd();

export default {
  name  : 'global-feed',
  mixins: [ErrorReporter],
  data  : function() {
    return {
      feedItems: null,
      feedTitle: null,
      feedId   : null,
    };
  },
  computed: {
    adsDisplayData: function () {
      return Config.FLEX_ONE_HARRIER_PARAMATER
    }
  },
  mounted() {
    // フィード取得
    const feedApiResult = apiClient.getFeed(this.feedParam)
    .then((response) => {
      if (response) {
        // フィード全体 で使用するもの取得
        this.feedTitle = response.title;
        this.feedId = response.feed_id;

        return this.addAdFeedItem(response.feeds.map((feed, index) => {
          feed.content_id = this.feedId + '_' + (index + 1);
          return feed;
        }));
      } else {
        this.report('Load feed-api failed');
        return [];
      }
    });

    feedApiResult.then((feedWithAds) => {
      this.feedItems = feedWithAds;
      return this.$nextTick();
    })
    .then(() => {
      // 広告表示用 処理
      feedAd.setAdDisplay(this.adParam, this.adsDisplayData);
    })
    .catch((error) => {
      console.log(error);
      const reporter = new ErrorReporter();
      reporter.report('Load feed failed', error);
    });
  },
  methods: {
    addAdFeedItem: function(getFeeds) {
      // 広告表示要素(id)をフィード指定箇所へ追加
      // ※フィード数が少ない場合は広告のみ表示
      for (let key in this.adsDisplayData) {
        // 広告用要素設定
        const adItem = {
          ad    : true,
          adId  : this.adsDisplayData[key].id,
          // 純広告用 パラメーター付与
          adPure: !!this.adsDisplayData[key].id.match(/feed-adp/),
        };
        getFeeds.splice(key, 0, adItem);
      }
      return getFeeds;
    },
  },
  props: {
    feedParam: {
      type    : Object,
      required: true,
    },
    adParam: {
      type    : Object,
      required: true,
    },
  },
  components: {
    FeedItem,
  },
};
</script>

<style lang="scss">
@charset "utf-8";

// import
@import "~@istyle-inc/global-navigation/sass/sp/global_feed";
</style>
